/*
 * Lazily loads the full Eric chat experience after a shopper opens the launcher.
 * The lightweight launcher is rendered by snippets/eg-chatbot.liquid.
 */
(function () {
  var loader = document.currentScript;
  var chatSource = loader && loader.dataset.chatSrc;
  var styleSource = loader && loader.dataset.chatStyle;
  var chatLoadPromise;

  function loadStyles() {
    if (!styleSource || document.querySelector('[data-egcb-chat-style]')) {
      return Promise.resolve();
    }

    return new Promise(function (resolve, reject) {
      var stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = styleSource;
      stylesheet.dataset.egcbChatStyle = 'true';
      stylesheet.onload = resolve;
      stylesheet.onerror = reject;
      document.head.appendChild(stylesheet);
    });
  }

  function loadChatRuntime() {
    if (!chatSource) {
      return Promise.reject(new Error('Chat runtime source is missing.'));
    }

    var existingRuntime = document.querySelector('[data-egcb-chat-runtime]');
    if (existingRuntime) {
      return new Promise(function (resolve, reject) {
        if (existingRuntime.dataset.loaded === 'true') {
          resolve();
          return;
        }

        existingRuntime.addEventListener('load', resolve, { once: true });
        existingRuntime.addEventListener('error', reject, { once: true });
      });
    }

    return new Promise(function (resolve, reject) {
      var runtime = document.createElement('script');
      runtime.src = chatSource;
      runtime.async = true;
      runtime.dataset.egcbChatRuntime = 'true';
      runtime.onload = function () {
        runtime.dataset.loaded = 'true';
        var root = document.getElementById('egcb-root');
        if (root && root.classList.contains('egcb-ready')) {
          resolve();
          return;
        }

        window.addEventListener('egcb:ready', resolve, { once: true });
      };
      runtime.onerror = reject;
      document.head.appendChild(runtime);
    });
  }

  window.EGLoadChat = function () {
    var root = document.getElementById('egcb-root');
    if (root && root.classList.contains('egcb-ready')) {
      return Promise.resolve();
    }

    if (!chatLoadPromise) {
      chatLoadPromise = loadStyles()
        .then(loadChatRuntime)
        .catch(function (error) {
          chatLoadPromise = null;
          throw error;
        });
    }

    return chatLoadPromise;
  };

  document.addEventListener('click', function (event) {
    var launcher = event.target.closest('[data-egcb-launcher], [data-egcb-open-chat]');
    if (!launcher) return;

    event.preventDefault();
    window.EGLoadChat()
      .then(function () {
        var toggle = document.querySelector('#egcb-root .egcb-toggle');
        if (toggle) toggle.click();
      })
      .catch(function (error) {
        console.error('[EGCB] Unable to load chat.', error);
      });
  });
})();
